// src/components/Toolbar/Toolbar.jsx
import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { ZoomIn, ZoomOut, RotateCcw, Sun, Moon, Contrast, Target, PanelLeftClose, PanelLeft } from 'lucide-react';
import './Toolbar.css';

const CONTRAST_OPTIONS = [
  { key: 'normal', icon: <Sun size={14} />, label: 'Normal' },
  { key: 'high', icon: <Contrast size={14} />, label: 'High Contrast' },
  { key: 'inverted', icon: <Moon size={14} />, label: 'Inverted' },
];

const Toolbar = memo(function Toolbar({
  zoom, onZoomIn, onZoomOut, onReset,
  diagramContrast, setDiagramContrast,
  autoZoom, setAutoZoom,
  sidebarOpen, setSidebarOpen,
  disabled,
}) {
  return (
    <motion.div
      className="toolbar glass"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
    >
      <button className="tb-btn" onClick={() => setSidebarOpen((o) => !o)} title="Toggle sidebar">
        {sidebarOpen ? <PanelLeftClose size={14} /> : <PanelLeft size={14} />}
      </button>

      <div className="tb-divider" />

      <button className="tb-btn" onClick={onZoomIn} disabled={disabled} title="Zoom in">
        <ZoomIn size={14} />
      </button>
      <div className="zoom-badge">{Math.round(zoom * 100)}%</div>
      <button className="tb-btn" onClick={onZoomOut} disabled={disabled} title="Zoom out">
        <ZoomOut size={14} />
      </button>
      <button className="tb-btn" onClick={onReset} disabled={disabled} title="Reset view">
        <RotateCcw size={14} />
      </button>

      <div className="tb-divider" />

      {CONTRAST_OPTIONS.map((opt) => (
        <button
          key={opt.key}
          className={`tb-btn ${diagramContrast === opt.key ? 'active' : ''}`}
          onClick={() => setDiagramContrast(opt.key)}
          disabled={disabled}
          title={opt.label}
        >
          {opt.icon}
        </button>
      ))}

      <div className="tb-divider" />

      <button
        className={`tb-btn ${autoZoom ? 'active' : ''}`}
        onClick={() => setAutoZoom((a) => !a)}
        disabled={disabled}
        title="Auto-zoom to component"
      >
        <Target size={14} />
      </button>
    </motion.div>
  );
});

export default Toolbar;
